module.exports = __webpack_public_path__ + "statics/img/cate1-6@2x.36161c36.png";